/** @enum string */
export const sources = Object.freeze({
  ANYGEO: "anygeo",
  GEOFOLIA: "geofolia",
  MANUAL: "",
  MESPARCELLES: "mesparcelles",
  CVI: "cvi",
  RPG: "rpg",
  SMAG_FARMER: "smagfarmer",
  TELEPAC: "telepac",
});
